var n=function(n){return n.full="full",n.partial="partial",n.none="none",n}({});export{n as AddressModeOptions};
//# sourceMappingURL=types.js.map
